
import React from "react";
import { useNavigate } from "react-router-dom";

export default function STPPreventiveCard({ count, countB, title, navLink, cardName, imgPath, STPPreventiveCardNavigate }) {
    const navigate = useNavigate()

    const handleSeweragePreventiveCardClick = () => {
        navigate(navLink)
    }
    return (

        <div style={{ height: '100%' }} className="mb-1 p-3 shadow blue_borders bg-white mb-md-2 daily-card-width" >
            {
                title == "Sewerage Quality" ?
                    <div className="d-flex flex-column justify-content-between" style={{ height: '100%' }}>

                        <div className="row d-flex justify-content-center align-items-center ">

                            <div className="col-6 col-lg-6 col-md-6  text-center" style={{ cursor: 'pointer', borderRight: "2px solid #cfc7c7" }}
                                onClick={() => STPPreventiveCardNavigate(title,'A')}
                            >
                                <h6><b>Quality A</b></h6>
                                <h4>{count ? count : '0'}</h4>
                            </div>

                            <div className="col-6 col-lg-6 col-md-6 text-center" style={{ cursor: 'pointer' }}
                                onClick={() => STPPreventiveCardNavigate(title,'B')}
                            >
                                <h6><b>Quality B</b></h6>
                                <h4>{countB ? countB : '0'}</h4>
                            </div>

                        </div>
                        <div style={{ borderLeft: '2px solid #0e4174f7' }}>
                            <h6 className="text-black ml-3"><b>{title}</b></h6>
                        </div>
                    </div>
                    :

                    <div className="d-flex flex-column justify-content-between" style={{ height: '100%', cursor: 'pointer' }}
                        onClick={() => STPPreventiveCardNavigate(title)}>
                        <div className="text-center" >
                            <div className="d-flex justify-content-between align-items-center">
                                <h4>{count}</h4>
                                <img className={cardName} style={{ height: '50px', width: '35px' }} src={imgPath} alt="" />
                            </div>

                        </div>
                        <div style={{ borderLeft: '2px solid #0e4174f7' }}>
                            <h6 className="text-black ml-3"><b>{title}</b></h6>
                        </div>
                    </div>
            }
        </div>

    )
}


